'use client'

import { usePathname } from 'next/navigation'

import { Paragraph } from '@graftcode/design-system'

import { useLayoutStore } from '../../stores/layout.store'
import { shouldHideAppLoader } from '../../utils/shouldHideAppLoader'

import styles from './Loader.module.scss'

export function Loader() {
  const pathname = usePathname()
  const { isLoading, loaderMessage, showLoaderOnSettings } = useLayoutStore()

  if (shouldHideAppLoader({ isLoading, pathname, showOnSettings: showLoaderOnSettings })) {
    return null
  }

  return (
    <div className={styles.overlay} data-testid="app-loader-overlay">
      <div className={styles.container}>
        <div className={styles.loader}>
          <div className={styles.spinner}></div>
        </div>

        <Paragraph size="sm" className={styles.message}>
          {loaderMessage}
        </Paragraph>
      </div>
    </div>
  )
}
